import "./SeparatorJF.css";
const SeparatorJF = ({
  width = "300px",
  color = "#0ea5e9",
  height = "2px",
}) => {
  return (
    <div className="separator-jf">
      <div
        className="separator-line"
        style={{
          width,
          height,
          "--separator-color": color,
        }}
      />
    </div>
  );
};

export default SeparatorJF;
